export default "__VITE_ASSET__9ac3b474__"